export const DEFAULT_MENU_ORIGIN = { x: 48, y: 15 };
export const MAIN_MENU_WIDTH = 328;

export const DOMAIN_TAB_TYPE = 'domain';

export const GET_STARTED_SECTION_TYPE = 'get-started';
export const CLP_SECTION_TYPE = 'clp';
export const POPULAR_SKILLS_SECTION_TYPE = 'skills';
export const CERTIFICATE_SECTION_TYPE = 'certificate';
export const DEGREES_SECTION_TYPE = 'degrees';
export const OTHER_SECTION_TYPE = 'other';
export const MASTERTRACK_SECTION_TYPE = 'mastertrack';

export const SECTION_VIEW_ALL_BUTTON_TYPE = 'SECTION_VIEW_ALL_BUTTON_TYPE';
export const SECTION_VIEW_ALL_LINK_TYPE = 'SECTION_VIEW_ALL_LINK_TYPE';

export const COLUMN_CONTENT_SECTION_TYPE = 'column';
export const BOTTOM_CONTENT_SECTION_TYPE = 'bottom';

export const DUAL_COLUMN_CONTENT_TYPE = 'dual_column';

export const MEGAMENU_SECTION_ID_GET_STARTED = 'get-started';
export const MEGAMENU_SECTION_ID_POPULAR_SKILLS = 'popular-skills';
export const MEGAMENU_SECTION_ID_CERTIFICATE_PROGRAMS = 'certificate-programs';

// background: https://coursera.slack.com/archives/C01CYUB2MB6/p1610147987003700
export const domainIdOrderFromKittHeuristic = [
  'data-science',
  'business',
  'computer-science',
  'information-technology',
  'language-learning',
  'life-sciences',
  'personal-development',
  'physical-science-and-engineering',
  'social-sciences',
  'arts-and-humanities',
  'math-and-logic',
];

export const DOMAIN_TOPICS_WITH_NO_PROFESSIONAL_CERTIFICATES = [
  'personal-development',
  'arts-and-humanities',
  'physical-science-and-engineering',
];

export default { DEFAULT_MENU_ORIGIN, domainIdOrderFromKittHeuristic };
